import { Button, Input, Form, Icon } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Swal from 'sweetalert2';
import UserEndpoint from '../../core-module/models/LoopBack/Models/UserEndpoint';
import { loopBackApi } from '../../core-module/models/LoopBack/Api/LoopBackApi';

interface LoginFormProps extends FormComponentProps {
  dispatch: Dispatch;
  onModeChange: (value: string) => void;
}

interface State {
  loading: boolean;
}

class LoginForm extends React.Component<LoginFormProps, State> {
  loopBackEndpoint: UserEndpoint;

  constructor(props) {
    super(props);
    this.loopBackEndpoint = new UserEndpoint();
    this.state = {
      loading: false
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.setState({ loading: true });
      loopBackApi()
        .post('users/reset', values)
        .then((res) => {
          this.setState({ loading: false });
          Swal({
            title: 'Email aangevraagd',
            text: `Er is een email verstuurd met daarin een link om je wachtwoord te resetten`,
            type: 'success',
            confirmButtonText: 'Ok'
          }).then((result) => {});
        })
        .catch((err) => {
          this.setState({ loading: false });
          Swal({
            title: 'Helaas',
            text: `Er is iets mis gegaan bij het aanvragen van de email`,
            type: 'error',
            confirmButtonText: 'Ok'
          }).then((result) => {});
        });
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className='login-form'>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Voer een geldige email in' }]
          })(<Input type={'email'} size={'large'} placeholder={'Email'} />)}
        </Form.Item>
        <Form.Item>
          <Button
            htmlType={'button'}
            type={'primary'}
            className='login-form-button'
            onClick={this.handleSubmit}
          >
            {this.state.loading && (
              <Icon type='loading' style={{ fontSize: 24, color: 'white' }} spin />
            )}
            Aanvragen
          </Button>
          <Button
            style={{ marginLeft: 5 }}
            htmlType={'button'}
            className='login-form-button'
            onClick={() => this.props.onModeChange('login')}
          >
            Naar login
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const DecoratedForm = Form.create()(LoginForm);

export default connect<any, any, any>(null, null)(DecoratedForm);
